module.exports = __webpack_public_path__ + "static/media/m_w_hb_45.d9009ae3.png";